import CreateVisitModal from '/@/components/field-list-v2/components/sidebar/components/create-visit-modal';
import { useFieldById } from '/@/hooks/fields';
import type { CropMonitoring } from '/@/types/crop-monitoring';
import { useFieldRegistryFlow } from './flow-tracking';
import type { RegistryAddStep } from './types';

const CreateRegistryVisitReport = ({
    open,
    onClose,
    setStep,
    fieldId,
    cropMonitoring: _cropMonitoring,
}: {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    setStep: (step: RegistryAddStep) => void;
    fieldId?: number;
    cropMonitoring?: CropMonitoring;
}) => {
    const fieldQuery = useFieldById({ id: fieldId ?? 0 }, { enabled: !!fieldId });
    // The report goes on with the attempt "Agregar registro" started
    const registryFlow = useFieldRegistryFlow();
    return (
        <CreateVisitModal
            open={open}
            setOpen={onClose}
            userNodeId={fieldQuery.data?.userNode ?? 0}
            field={fieldQuery.data}
            entrySource='field-registry'
            registryFlow={registryFlow}
        />
    );
};

export default CreateRegistryVisitReport;
